/**
 * Vue Index CONST
 */
export const VUE_SAVED = 0;
export const VUE_HOME = 1;
export const VUE_SEARCH = 2;


/**
 * Actions
 */
export const UPDATE_POSITION = 'UPDATE_POSITION';
export const UPDATE_WEATHER = 'UPDATE_WEATHER';
export const UPDATE_AUTOCOMPLETE = 'UPDATE_AUTOCOMPLETE';
export const UPDATE_FORECAST = 'UPDATE_FORECAST';
export const DELETE_SUGGESTION = 'DELETE_SUGGESTION';

export const CHANGE_INDEX_VUE = 'CHANGE_INDEX_VUE';

export const ADD_SAVED_ITEM = 'ADD_SAVED_ITEM';
export const REMOVE_SAVED_ITEM = 'REMOVE_SAVED_ITEM';







// WEBPACK FOOTER //
// ./src/store/actions/actions.js